export const ON_CHANGE_LANGUAGE         = 'ON_CHANGE_LANGUAGE';